export const profilePageTranslations = {
  en: {
    'profile.pageTitle': 'Profile Management',
    'profile.pageSubtitle': 'Manage your account information and settings',
    'profile.title': 'Profile Management',
    'profile.subtitle': 'Manage your account information and settings',
    'profile.loading': 'Loading profile...',
    'profile.failed_to_load': 'Failed to load profile',
    'profile.retry': 'Retry',
    'profile.basic_info': 'Basic Information',
    'profile.first_name': 'First Name',
    'profile.last_name': 'Last Name',
    'profile.contact_info': 'Contact Information',
    'profile.security': 'Security Settings',
    'vaiu.profile_page.title': 'Profile Management',
    'vaiu.profile_page.subtitle': 'Manage your account information and settings',
    'vaiu.profile_page.loading': 'Loading profile...',
    'vaiu.profile_page.failed_to_load': 'Failed to load profile',
    'vaiu.profile_page.retry': 'Retry',
    'vaiu.profile_page.basic_info': 'Basic Information',
    'vaiu.profile_page.first_name': 'First Name',
    'vaiu.profile_page.last_name': 'Last Name',
    'vaiu.profile_page.username': 'Username',
    'vaiu.profile_page.contact_info': 'Contact Information',
    'vaiu.profile_page.security': 'Security Settings',
    'vaiu.profile_page.transfer_out.title': 'Transfer Out Preferences',
    'vaiu.profile_page.transfer_out.description': 'Configure your preferred payment methods for transferring funds out of your account.',
    'vaiu.profile_page.transfer_out.paypal_email': 'PayPal Email',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'This email will be used for PayPal payouts when you transfer funds out.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Enabled Payment Methods',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Choose which payment methods you want to use for transferring funds out.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transfer funds to your PayPal account',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Bank Accounts',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transfer funds to your connected bank accounts',
    'vaiu.profile_page.transfer_out.merchant_info': 'Merchant Information',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Stripe Connect Account',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Connected: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Not connected - Set up Stripe Connect for direct transfers',
    'vaiu.profile_page.transfer_out.not_set': 'Not set',
    'vaiu.profile_page.transfer_out.configured': 'Configured',
    'vaiu.profile_page.transfer_out.not_configured': 'Not Set',
    'vaiu.profile_page.transfer_out.enabled': 'Enabled',
    'vaiu.profile_page.transfer_out.disabled': 'Disabled',
    'vaiu.profile_page.transfer_out.payouts_title': 'Payouts (transfer out)',
    'vaiu.profile_page.transfer_out.payouts_intro': 'Verify the PayPal email that should receive payouts. We email a one-time code to that address — enter it below to confirm.',
    'vaiu.profile_page.transfer_out.paypal_email_label': 'PayPal payout email',
    'vaiu.profile_page.transfer_out.send_code': 'Email verification code',
    'vaiu.profile_page.transfer_out.code_label': '6-digit code',
    'vaiu.profile_page.transfer_out.verify': 'Verify email',
    'vaiu.profile_page.transfer_out.verified': 'Verified',
    'vaiu.profile_page.transfer_out.not_verified': 'Not verified',
    'vaiu.profile_page.transfer_out.toggle_requires_verify': 'Enable after the email above is verified',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'MeMoney (MM$) balances are still being tested end-to-end. Amounts and timing may not be final.',

    'profile.overview': 'Profile Overview',
    'profile.balances': 'Account Balances',
    'profile.landingPage': 'Landing Page Preferences',
    'profile.addresses': 'Addresses',
    'profile.transferOut': 'Transfer Out Preferences',
    'profile.autoDeposit': 'Auto-Deposit Preferences',
    'profile.businessSettings': 'Business Settings',
    'profile.accountInfo': 'Account Information',
    'profile.debugInfo': 'Debug Information',
    'profile.toast.failedToLoad': 'Failed to load profile data',
    'profile.toast.emailVerified': 'Email verified successfully! Welcome to VAIU!',
    'profile.toast.emailVerificationFailed': 'Email verification failed. The link may be expired or invalid.',
    'profile.toast.googleMapsFailed': 'Failed to load Google Maps. Please check your internet connection.',
    'profile.toast.autoDepositUpdated': 'Auto-deposit preferences updated successfully',
    'profile.toast.autoDepositFailed': 'Failed to update auto-deposit preferences',
    'profile.toast.autoAcceptUpdated': 'Auto-accept preferences updated successfully',
    'profile.toast.autoAcceptFailed': 'Failed to update auto-accept preferences',
    'profile.toast.invoicePaymentUpdated': 'Invoice payment preferences updated successfully',
    'profile.toast.profileUpdated': 'Profile updated successfully',
    'profile.toast.profileUpdateFailed': 'Failed to update profile',
    'profile.toast.verificationEmailSent': 'Verification email sent',
    'profile.toast.verificationEmailFailed': 'Failed to send verification email',
    'profile.toast.pinsDoNotMatch': 'PINs do not match',
    'profile.toast.pinUpdated': 'PIN updated successfully',
    'profile.toast.pinUpdateFailed': 'Failed to update PIN',
    'profile.toast.pinSettingUpdated': 'PIN setting updated',
    'profile.toast.pinSettingFailed': 'Failed to update PIN setting',
    'profile.toast.transferOutUpdated': 'Transfer out preferences updated successfully',
    'profile.toast.transferOutFailed': 'Failed to update transfer out preferences',
    'profile.toast.paypalVerificationSent': 'Verification code sent. Check that PayPal email inbox.',
    'profile.toast.paypalVerificationSendFailed': 'Could not send verification code',
    'profile.toast.paypalVerified': 'PayPal email verified and saved',
    'profile.toast.paypalVerifyFailed': 'Verification failed',
    'profile.toast.addressAdded': 'Address added successfully',
    'profile.toast.addressUpdated': 'Address updated successfully',
    'profile.toast.addressDeleteFailed': 'Failed to save address',
    'profile.toast.addressDeleted': 'Address deleted successfully',
    'profile.toast.addressDeleteError': 'Failed to delete address',
    'profile.toast.primaryAddressUpdated': 'Primary address updated',
    'profile.toast.primaryAddressFailed': 'Failed to update primary address',
    'profile.toast.merchantStatusEnabled': 'Merchant status enabled',
    'profile.toast.merchantStatusDisabled': 'Merchant status disabled',
    'profile.toast.merchantStatusFailed': 'Failed to update merchant status',
    'profile.toast.developerAccessEnabled': 'Developer access enabled! You can now access the Developer Console.',
    'profile.toast.developerAccessFailed': 'Failed to enable developer access',
  },
  es: {
    'profile.pageTitle': 'Gestión de Perfil',
    'profile.pageSubtitle': 'Gestiona la información y configuración de tu cuenta',
    'profile.title': 'Gestión de Perfil',
    'profile.subtitle': 'Gestiona la información y configuración de tu cuenta',
    'profile.loading': 'Cargando perfil...',
    'profile.failed_to_load': 'Error al cargar el perfil',
    'profile.retry': 'Reintentar',
    'profile.basic_info': 'Información Básica',
    'profile.first_name': 'Nombre',
    'profile.last_name': 'Apellido',
    'profile.contact_info': 'Información de Contacto',
    'profile.security': 'Configuración de Seguridad',
    'vaiu.profile_page.title': 'Gestión de Perfil',
    'vaiu.profile_page.subtitle': 'Gestiona la información y configuración de tu cuenta',
    'vaiu.profile_page.loading': 'Cargando perfil...',
    'vaiu.profile_page.failed_to_load': 'Error al cargar el perfil',
    'vaiu.profile_page.retry': 'Reintentar',
    'vaiu.profile_page.basic_info': 'Información Básica',
    'vaiu.profile_page.first_name': 'Nombre',
    'vaiu.profile_page.last_name': 'Apellido',
    'vaiu.profile_page.username': 'Nombre de usuario',
    'vaiu.profile_page.contact_info': 'Información de Contacto',
    'vaiu.profile_page.security': 'Configuración de Seguridad',
    'vaiu.profile_page.transfer_out.title': 'Preferencias de Transferencia de Salida',
    'vaiu.profile_page.transfer_out.description': 'Configura tus métodos de pago preferidos para transferir fondos de tu cuenta.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Correo de PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Este correo se utilizará para los pagos de PayPal cuando transfieras fondos.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Métodos de Pago Habilitados',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Elige qué métodos de pago quieres usar para transferir fondos.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transferir fondos a tu cuenta de PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Cuentas Bancarias',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transferir fondos a tus cuentas bancarias conectadas',
    'vaiu.profile_page.transfer_out.merchant_info': 'Información del Comerciante',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Cuenta de Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Conectado: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'No conectado - Configura Stripe Connect para transferencias directas',
    'vaiu.profile_page.transfer_out.not_set': 'No establecido',
    'vaiu.profile_page.transfer_out.configured': 'Configurado',
    'vaiu.profile_page.transfer_out.not_configured': 'No Configurado',
    'vaiu.profile_page.transfer_out.enabled': 'Habilitado',
    'vaiu.profile_page.transfer_out.disabled': 'Deshabilitado',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Los saldos MeMoney (MM$) siguen en pruebas; los importes y plazos pueden no ser definitivos.',

    'profile.overview': 'Resumen del Perfil',
    'profile.balances': 'Saldos de la Cuenta',
    'profile.landingPage': 'Preferencias de la Página de Inicio',
    'profile.addresses': 'Direcciones',
    'profile.transferOut': 'Preferencias de Transferencia de Salida',
    'profile.autoDeposit': 'Preferencias de Depósito Automático',
    'profile.businessSettings': 'Configuración del Negocio',
    'profile.accountInfo': 'Información de la Cuenta',
    'profile.debugInfo': 'Información de Depuración',
    'profile.toast.failedToLoad': 'Error al cargar los datos del perfil',
    'profile.toast.emailVerified': '¡Correo electrónico verificado con éxito! ¡Bienvenido a VAIU!',
    'profile.toast.emailVerificationFailed': 'La verificación del correo electrónico falló. El enlace puede haber expirado o ser inválido.',
    'profile.toast.googleMapsFailed': 'Error al cargar Google Maps. Por favor, verifica tu conexión a internet.',
    'profile.toast.autoDepositUpdated': 'Preferencias de depósito automático actualizadas con éxito',
    'profile.toast.autoDepositFailed': 'Error al actualizar las preferencias de depósito automático',
    'profile.toast.autoAcceptUpdated': 'Preferencias de aceptación automática actualizadas con éxito',
    'profile.toast.autoAcceptFailed': 'Error al actualizar las preferencias de aceptación automática',
    'profile.toast.invoicePaymentUpdated': 'Preferencias de pago de facturas actualizadas con éxito',
    'profile.toast.profileUpdated': 'Perfil actualizado con éxito',
    'profile.toast.profileUpdateFailed': 'Error al actualizar el perfil',
    'profile.toast.verificationEmailSent': 'Correo de verificación enviado',
    'profile.toast.verificationEmailFailed': 'Error al enviar el correo de verificación',
    'profile.toast.pinsDoNotMatch': 'Los PIN no coinciden',
    'profile.toast.pinUpdated': 'PIN actualizado con éxito',
    'profile.toast.pinUpdateFailed': 'Error al actualizar el PIN',
    'profile.toast.pinSettingUpdated': 'Configuración del PIN actualizada',
    'profile.toast.pinSettingFailed': 'Error al actualizar la configuración del PIN',
    'profile.toast.transferOutUpdated': 'Preferencias de transferencia de salida actualizadas con éxito',
    'profile.toast.transferOutFailed': 'Error al actualizar las preferencias de transferencia de salida',
    'profile.toast.addressAdded': 'Dirección añadida con éxito',
    'profile.toast.addressUpdated': 'Dirección actualizada con éxito',
    'profile.toast.addressDeleteFailed': 'Error al guardar la dirección',
    'profile.toast.addressDeleted': 'Dirección eliminada con éxito',
    'profile.toast.addressDeleteError': 'Error al eliminar la dirección',
    'profile.toast.primaryAddressUpdated': 'Dirección principal actualizada',
    'profile.toast.primaryAddressFailed': 'Error al actualizar la dirección principal',
    'profile.toast.merchantStatusEnabled': 'Estado de comerciante habilitado',
    'profile.toast.merchantStatusDisabled': 'Estado de comerciante deshabilitado',
    'profile.toast.merchantStatusFailed': 'Error al actualizar el estado de comerciante',
    'profile.toast.developerAccessEnabled': '¡Acceso de desarrollador habilitado! Ahora puedes acceder a la Consola de Desarrollador.',
    'profile.toast.developerAccessFailed': 'Error al habilitar el acceso de desarrollador',
  },
  fr: {
    'profile.pageTitle': 'Gestion du profil',
    'profile.pageSubtitle': 'Gérez les informations et paramètres de votre compte',
    'profile.title': 'Gestion du profil',
    'profile.subtitle': 'Gérez les informations et paramètres de votre compte',
    'profile.loading': 'Chargement du profil...',
    'profile.failed_to_load': 'Échec du chargement du profil',
    'profile.retry': 'Réessayer',
    'profile.basic_info': 'Informations de Base',
    'profile.first_name': 'Prénom',
    'profile.last_name': 'Nom de Famille',
    'profile.contact_info': 'Informations de Contact',
    'profile.security': 'Paramètres de Sécurité',
    'vaiu.profile_page.title': 'Gestion du profil',
    'vaiu.profile_page.subtitle': 'Gérez les informations et paramètres de votre compte',
    'vaiu.profile_page.loading': 'Chargement du profil...',
    'vaiu.profile_page.failed_to_load': 'Échec du chargement du profil',
    'vaiu.profile_page.retry': 'Réessayer',
    'vaiu.profile_page.basic_info': 'Informations de Base',
    'vaiu.profile_page.first_name': 'Prénom',
    'vaiu.profile_page.last_name': 'Nom de Famille',
    'vaiu.profile_page.username': "Nom d'utilisateur",
    'vaiu.profile_page.contact_info': 'Informations de Contact',
    'vaiu.profile_page.security': 'Paramètres de Sécurité',
    'vaiu.profile_page.transfer_out.title': 'Préférences de Transfert Sortant',
    'vaiu.profile_page.transfer_out.description': 'Configurez vos méthodes de paiement préférées pour transférer des fonds de votre compte.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Cet email sera utilisé pour les paiements PayPal lorsque vous transférerez des fonds.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Méthodes de Paiement Activées',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Choisissez les méthodes de paiement que vous souhaitez utiliser pour transférer des fonds.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transférer des fonds vers votre compte PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Comptes Bancaires',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transférer des fonds vers vos comptes bancaires connectés',
    'vaiu.profile_page.transfer_out.merchant_info': 'Informations du Marchand',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Compte Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Connecté : {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Non connecté - Configurez Stripe Connect pour les transferts directs',
    'vaiu.profile_page.transfer_out.not_set': 'Non défini',
    'vaiu.profile_page.transfer_out.configured': 'Configuré',
    'vaiu.profile_page.transfer_out.not_configured': 'Non Configuré',
    'vaiu.profile_page.transfer_out.enabled': 'Activé',
    'vaiu.profile_page.transfer_out.disabled': 'Désactivé',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Les soldes MeMoney (MM$) sont encore en validation ; les montants et délais peuvent ne pas être définitifs.',

    'profile.overview': 'Aperçu du profil',
    'profile.balances': 'Soldes du compte',
    'profile.landingPage': 'Préférences de la page d\'accueil',
    'profile.addresses': 'Adresses',
    'profile.transferOut': 'Préférences de transfert sortant',
    'profile.autoDeposit': 'Préférences de dépôt automatique',
    'profile.businessSettings': 'Paramètres commerciaux',
    'profile.accountInfo': 'Informations du compte',
    'profile.debugInfo': 'Informations de débogage',
    'profile.toast.failedToLoad': 'Échec du chargement des données du profil',
    'profile.toast.emailVerified': 'Email vérifié avec succès ! Bienvenue sur VAIU !',
    'profile.toast.emailVerificationFailed': 'La vérification de l\'email a échoué. Le lien peut avoir expiré ou être invalide.',
    'profile.toast.googleMapsFailed': 'Échec du chargement de Google Maps. Veuillez vérifier votre connexion Internet.',
    'profile.toast.autoDepositUpdated': 'Préférences de dépôt automatique mises à jour avec succès',
    'profile.toast.autoDepositFailed': 'Échec de la mise à jour des préférences de dépôt automatique',
    'profile.toast.autoAcceptUpdated': 'Préférences d\'acceptation automatique mises à jour avec succès',
    'profile.toast.autoAcceptFailed': 'Échec de la mise à jour des préférences d\'acceptation automatique',
    'profile.toast.invoicePaymentUpdated': 'Préférences de paiement de facture mises à jour avec succès',
    'profile.toast.profileUpdated': 'Profil mis à jour avec succès',
    'profile.toast.profileUpdateFailed': 'Échec de la mise à jour du profil',
    'profile.toast.verificationEmailSent': 'Email de vérification envoyé',
    'profile.toast.verificationEmailFailed': 'Échec de l\'envoi de l\'email de vérification',
    'profile.toast.pinsDoNotMatch': 'Les codes PIN ne correspondent pas',
    'profile.toast.pinUpdated': 'Code PIN mis à jour avec succès',
    'profile.toast.pinUpdateFailed': 'Échec de la mise à jour du code PIN',
    'profile.toast.pinSettingUpdated': 'Paramètre du code PIN mis à jour',
    'profile.toast.pinSettingFailed': 'Échec de la mise à jour du paramètre du code PIN',
    'profile.toast.transferOutUpdated': 'Préférences de transfert sortant mises à jour avec succès',
    'profile.toast.transferOutFailed': 'Échec de la mise à jour des préférences de transfert sortant',
    'profile.toast.addressAdded': 'Adresse ajoutée avec succès',
    'profile.toast.addressUpdated': 'Adresse mise à jour avec succès',
    'profile.toast.addressDeleteFailed': 'Échec de l\'enregistrement de l\'adresse',
    'profile.toast.addressDeleted': 'Adresse supprimée avec succès',
    'profile.toast.addressDeleteError': 'Échec de la suppression de l\'adresse',
    'profile.toast.primaryAddressUpdated': 'Adresse principale mise à jour',
    'profile.toast.primaryAddressFailed': 'Échec de la mise à jour de l\'adresse principale',
    'profile.toast.merchantStatusEnabled': 'Statut de commerçant activé',
    'profile.toast.merchantStatusDisabled': 'Statut de commerçant désactivé',
    'profile.toast.merchantStatusFailed': 'Échec de la mise à jour du statut de commerçant',
    'profile.toast.developerAccessEnabled': 'Accès développeur activé ! Vous pouvez maintenant accéder à la Console Développeur.',
    'profile.toast.developerAccessFailed': 'Échec de l\'activation de l\'accès développeur',
  },
  sq: {
    'profile.pageTitle': 'Menaxhimi i Profilit',
    'profile.pageSubtitle': 'Menaxhoni informacionet dhe cilësimet e llogarisë suaj',
    'profile.title': 'Menaxhimi i Profilit',
    'profile.subtitle': 'Menaxhoni informacionet dhe cilësimet e llogarisë suaj',
    'profile.loading': 'Duke ngarkuar profilin...',
    'profile.failed_to_load': 'Dështoi ngarkimi i profilit',
    'profile.retry': 'Provo Përsëri',
    'profile.basic_info': 'Informacioni Bazë',
    'profile.first_name': 'Emri',
    'profile.last_name': 'Mbiemri',
    'profile.contact_info': 'Informacioni i Kontaktit',
    'profile.security': 'Cilësimet e Sigurisë',
    'vaiu.profile_page.title': 'Menaxhimi i Profilit',
    'vaiu.profile_page.subtitle': 'Menaxhoni informacionet dhe cilësimet e llogarisë suaj',
    'vaiu.profile_page.loading': 'Duke ngarkuar profilin...',
    'vaiu.profile_page.failed_to_load': 'Dështoi ngarkimi i profilit',
    'vaiu.profile_page.retry': 'Provo Përsëri',
    'vaiu.profile_page.basic_info': 'Informacioni Bazë',
    'vaiu.profile_page.first_name': 'Emri',
    'vaiu.profile_page.last_name': 'Mbiemri',
    'vaiu.profile_page.username': 'Emri i përdoruesit',
    'vaiu.profile_page.contact_info': 'Informacioni i Kontaktit',
    'vaiu.profile_page.security': 'Cilësimet e Sigurisë',
    'vaiu.profile_page.transfer_out.title': 'Preferencat e Transferimit Jashtë',
    'vaiu.profile_page.transfer_out.description': 'Konfiguroni metodat e pagesës tuaja të preferuara për transferimin e fondeve nga llogaria juaj.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Ky email do të përdoret për pagesat PayPal kur transferoni fonde.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Metodat e Pagesës të Aktivizuara',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Zgjidhni metodat e pagesës që dëshironi të përdorni për transferimin e fondeve.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transferoni fonde në llogarinë tuaj PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Llogaritë Bankare',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transferoni fonde në llogaritë tuaja bankare të lidhura',
    'vaiu.profile_page.transfer_out.merchant_info': 'Informacioni i Tregtarit',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Llogaria Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'E lidhur: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Jo e lidhur - Konfiguroni Stripe Connect për transferime direkte',
    'vaiu.profile_page.transfer_out.not_set': 'Jo e vendosur',
    'vaiu.profile_page.transfer_out.configured': 'E konfiguruar',
    'vaiu.profile_page.transfer_out.not_configured': 'Jo e Konfiguruar',
    'vaiu.profile_page.transfer_out.enabled': 'E aktivizuar',
    'vaiu.profile_page.transfer_out.disabled': 'E çaktivizuar',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Bilancet MeMoney (MM$) janë ende në testim; shumat dhe kohët mund të mos jenë përfundimtare.',

    'profile.overview': 'Përmbledhje Profili',
    'profile.balances': 'Balancat e Llogarisë',
    'profile.landingPage': 'Preferencat e Faqes së Fillimit',
    'profile.addresses': 'Adresat',
    'profile.transferOut': 'Preferencat e Transferimit Jashtë',
    'profile.autoDeposit': 'Preferencat e Depozitës Automatike',
    'profile.businessSettings': 'Cilësimet e Biznesit',
    'profile.accountInfo': 'Informacioni i Llogarisë',
    'profile.debugInfo': 'Informacioni i Debug',
    'profile.toast.failedToLoad': 'Dështoi ngarkimi i të dhënave të profilit',
    'profile.toast.emailVerified': 'Email u verifikua me sukses! Mirë se vini në VAIU!',
    'profile.toast.emailVerificationFailed': 'Verifikimi i email-it dështoi. Lidhja mund të ketë skaduar ose të jetë e pavlefshme.',
    'profile.toast.googleMapsFailed': 'Dështoi ngarkimi i Google Maps. Ju lutem kontrolloni lidhjen tuaj me internet.',
    'profile.toast.autoDepositUpdated': 'Preferencat e depozitimit automatik u përditësuan me sukses',
    'profile.toast.autoDepositFailed': 'Dështoi përditësimi i preferencave të depozitimit automatik',
    'profile.toast.autoAcceptUpdated': 'Preferencat e pranimit automatik u përditësuan me sukses',
    'profile.toast.autoAcceptFailed': 'Dështoi përditësimi i preferencave të pranimit automatik',
    'profile.toast.invoicePaymentUpdated': 'Preferencat e pagesës së faturës u përditësuan me sukses',
    'profile.toast.profileUpdated': 'Profili u përditësua me sukses',
    'profile.toast.profileUpdateFailed': 'Dështoi përditësimi i profilit',
    'profile.toast.verificationEmailSent': 'Email verifikimi u dërgua',
    'profile.toast.verificationEmailFailed': 'Dështoi dërgimi i email-it të verifikimit',
    'profile.toast.pinsDoNotMatch': 'PIN-et nuk përputhen',
    'profile.toast.pinUpdated': 'PIN u përditësua me sukses',
    'profile.toast.pinUpdateFailed': 'Dështoi përditësimi i PIN-it',
    'profile.toast.pinSettingUpdated': 'Cilësimi i PIN-it u përditësua',
    'profile.toast.pinSettingFailed': 'Dështoi përditësimi i cilësimit të PIN-it',
    'profile.toast.transferOutUpdated': 'Preferencat e transferimit jashtë u përditësuan me sukses',
    'profile.toast.transferOutFailed': 'Dështoi përditësimi i preferencave të transferimit jashtë',
    'profile.toast.addressAdded': 'Adresa u shtua me sukses',
    'profile.toast.addressUpdated': 'Adresa u përditësua me sukses',
    'profile.toast.addressDeleteFailed': 'Dështoi ruajtja e adresës',
    'profile.toast.addressDeleted': 'Adresa u fshi me sukses',
    'profile.toast.addressDeleteError': 'Dështoi fshirja e adresës',
    'profile.toast.primaryAddressUpdated': 'Adresa kryesore u përditësua',
    'profile.toast.primaryAddressFailed': 'Dështoi përditësimi i adresës kryesore',
    'profile.toast.merchantStatusEnabled': 'Statusi i tregtarit u aktivizua',
    'profile.toast.merchantStatusDisabled': 'Statusi i tregtarit u çaktivizua',
    'profile.toast.merchantStatusFailed': 'Dështoi përditësimi i statusit të tregtarit',
    'profile.toast.developerAccessEnabled': 'Qasja e zhvilluesit u aktivizua! Tani mund të hyni në Konsolën e Zhvilluesit.',
    'profile.toast.developerAccessFailed': 'Dështoi aktivizimi i qasjes së zhvilluesit',
  },
  ru: {
    'profile.pageTitle': 'Управление профилем',
    'profile.pageSubtitle': 'Управляйте информацией и настройками вашего аккаунта',
    'profile.title': 'Управление профилем',
    'profile.subtitle': 'Управляйте информацией и настройками вашего аккаунта',
    'profile.loading': 'Загрузка профиля...',
    'profile.failed_to_load': 'Не удалось загрузить профиль',
    'profile.retry': 'Повторить',
    'profile.basic_info': 'Основная Информация',
    'profile.first_name': 'Имя',
    'profile.last_name': 'Фамилия',
    'profile.contact_info': 'Контактная Информация',
    'profile.security': 'Настройки Безопасности',
    'vaiu.profile_page.title': 'Управление профилем',
    'vaiu.profile_page.subtitle': 'Управляйте информацией и настройками вашего аккаунта',
    'vaiu.profile_page.loading': 'Загрузка профиля...',
    'vaiu.profile_page.failed_to_load': 'Не удалось загрузить профиль',
    'vaiu.profile_page.retry': 'Повторить',
    'vaiu.profile_page.basic_info': 'Основная Информация',
    'vaiu.profile_page.first_name': 'Имя',
    'vaiu.profile_page.last_name': 'Фамилия',
    'vaiu.profile_page.username': 'Имя пользователя',
    'vaiu.profile_page.contact_info': 'Контактная Информация',
    'vaiu.profile_page.security': 'Настройки Безопасности',
    'vaiu.profile_page.transfer_out.title': 'Настройки вывода средств',
    'vaiu.profile_page.transfer_out.description': 'Настройте предпочитаемые способы оплаты для вывода средств с вашего счета.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Этот email будет использоваться для выплат PayPal при выводе средств.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Включенные способы оплаты',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Выберите способы оплаты, которые вы хотите использовать для вывода средств.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Перевести средства на ваш счет PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Банковские счета',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Перевести средства на ваши подключенные банковские счета',
    'vaiu.profile_page.transfer_out.merchant_info': 'Информация о продавце',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Аккаунт Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Подключено: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Не подключено - Настройте Stripe Connect для прямых переводов',
    'vaiu.profile_page.transfer_out.not_set': 'Не установлено',
    'vaiu.profile_page.transfer_out.configured': 'Настроено',
    'vaiu.profile_page.transfer_out.not_configured': 'Не настроено',
    'vaiu.profile_page.transfer_out.enabled': 'Включено',
    'vaiu.profile_page.transfer_out.disabled': 'Отключено',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Балансы MeMoney (MM$) всё ещё проходят сквозное тестирование; суммы и сроки могут быть неточными.',

    'profile.overview': 'Обзор профиля',
    'profile.balances': 'Балансы аккаунта',
    'profile.landingPage': 'Настройки главной страницы',
    'profile.addresses': 'Адреса',
    'profile.transferOut': 'Настройки перевода средств',
    'profile.autoDeposit': 'Настройки автоматического депозита',
    'profile.businessSettings': 'Бизнес-настройки',
    'profile.accountInfo': 'Информация об аккаунте',
    'profile.debugInfo': 'Отладочная информация',
    'profile.toast.failedToLoad': 'Не удалось загрузить данные профиля',
    'profile.toast.emailVerified': 'Email успешно подтвержден! Добро пожаловать в VAIU!',
    'profile.toast.emailVerificationFailed': 'Подтверждение email не удалось. Ссылка могла истечь или быть недействительной.',
    'profile.toast.googleMapsFailed': 'Не удалось загрузить Google Maps. Пожалуйста, проверьте подключение к интернету.',
    'profile.toast.autoDepositUpdated': 'Настройки автоматического депозита успешно обновлены',
    'profile.toast.autoDepositFailed': 'Не удалось обновить настройки автоматического депозита',
    'profile.toast.autoAcceptUpdated': 'Настройки автоматического принятия успешно обновлены',
    'profile.toast.autoAcceptFailed': 'Не удалось обновить настройки автоматического принятия',
    'profile.toast.invoicePaymentUpdated': 'Настройки оплаты счетов успешно обновлены',
    'profile.toast.profileUpdated': 'Профиль успешно обновлен',
    'profile.toast.profileUpdateFailed': 'Не удалось обновить профиль',
    'profile.toast.verificationEmailSent': 'Письмо с подтверждением отправлено',
    'profile.toast.verificationEmailFailed': 'Не удалось отправить письмо с подтверждением',
    'profile.toast.pinsDoNotMatch': 'PIN-коды не совпадают',
    'profile.toast.pinUpdated': 'PIN-код успешно обновлен',
    'profile.toast.pinUpdateFailed': 'Не удалось обновить PIN-код',
    'profile.toast.pinSettingUpdated': 'Настройка PIN-кода обновлена',
    'profile.toast.pinSettingFailed': 'Не удалось обновить настройку PIN-кода',
    'profile.toast.transferOutUpdated': 'Настройки перевода средств успешно обновлены',
    'profile.toast.transferOutFailed': 'Не удалось обновить настройки перевода средств',
    'profile.toast.addressAdded': 'Адрес успешно добавлен',
    'profile.toast.addressUpdated': 'Адрес успешно обновлен',
    'profile.toast.addressDeleteFailed': 'Не удалось сохранить адрес',
    'profile.toast.addressDeleted': 'Адрес успешно удален',
    'profile.toast.addressDeleteError': 'Не удалось удалить адрес',
    'profile.toast.primaryAddressUpdated': 'Основной адрес обновлен',
    'profile.toast.primaryAddressFailed': 'Не удалось обновить основной адрес',
    'profile.toast.merchantStatusEnabled': 'Статус продавца включен',
    'profile.toast.merchantStatusDisabled': 'Статус продавца отключен',
    'profile.toast.merchantStatusFailed': 'Не удалось обновить статус продавца',
    'profile.toast.developerAccessEnabled': 'Доступ разработчика включен! Теперь вы можете получить доступ к Консоли разработчика.',
    'profile.toast.developerAccessFailed': 'Не удалось включить доступ разработчика',
  },
  pt: {
    'profile.pageTitle': 'Gerenciamento de Perfil',
    'profile.pageSubtitle': 'Gerencie as informações e configurações da sua conta',
    'profile.title': 'Gerenciamento de Perfil',
    'profile.subtitle': 'Gerencie as informações e configurações da sua conta',
    'profile.loading': 'Carregando perfil...',
    'profile.failed_to_load': 'Falha ao carregar perfil',
    'profile.retry': 'Tentar Novamente',
    'profile.basic_info': 'Informações Básicas',
    'profile.first_name': 'Nome',
    'profile.last_name': 'Sobrenome',
    'profile.contact_info': 'Informações de Contato',
    'profile.security': 'Configurações de Segurança',
    'vaiu.profile_page.title': 'Gerenciamento de Perfil',
    'vaiu.profile_page.subtitle': 'Gerencie as informações e configurações da sua conta',
    'vaiu.profile_page.loading': 'Carregando perfil...',
    'vaiu.profile_page.failed_to_load': 'Falha ao carregar perfil',
    'vaiu.profile_page.retry': 'Tentar Novamente',
    'vaiu.profile_page.basic_info': 'Informações Básicas',
    'vaiu.profile_page.first_name': 'Nome',
    'vaiu.profile_page.last_name': 'Sobrenome',
    'vaiu.profile_page.username': 'Nome de usuário',
    'vaiu.profile_page.contact_info': 'Informações de Contato',
    'vaiu.profile_page.security': 'Configurações de Segurança',
    'vaiu.profile_page.transfer_out.title': 'Preferências de Transferência de Saída',
    'vaiu.profile_page.transfer_out.description': 'Configure seus métodos de pagamento preferidos para transferir fundos da sua conta.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email do PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Este email será usado para pagamentos do PayPal quando você transferir fundos.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Métodos de Pagamento Habilitados',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Escolha quais métodos de pagamento você deseja usar para transferir fundos.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transferir fundos para sua conta PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Contas Bancárias',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transferir fundos para suas contas bancárias conectadas',
    'vaiu.profile_page.transfer_out.merchant_info': 'Informações do Comerciante',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Conta Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Conectado: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Não conectado - Configure o Stripe Connect para transferências diretas',
    'vaiu.profile_page.transfer_out.not_set': 'Não definido',
    'vaiu.profile_page.transfer_out.configured': 'Configurado',
    'vaiu.profile_page.transfer_out.not_configured': 'Não Configurado',
    'vaiu.profile_page.transfer_out.enabled': 'Habilitado',
    'vaiu.profile_page.transfer_out.disabled': 'Desabilitado',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Saldos MeMoney (MM$) ainda estão em testes ponta a ponta; valores e prazos podem não ser finais.',

    'profile.overview': 'Visão Geral do Perfil',
    'profile.balances': 'Saldos da Conta',
    'profile.landingPage': 'Preferências da Página Inicial',
    'profile.addresses': 'Endereços',
    'profile.transferOut': 'Preferências de Transferência de Saída',
    'profile.autoDeposit': 'Preferências de Depósito Automático',
    'profile.businessSettings': 'Configurações Comerciais',
    'profile.accountInfo': 'Informações da Conta',
    'profile.debugInfo': 'Informações de Depuração',
    'profile.toast.failedToLoad': 'Falha ao carregar dados do perfil',
    'profile.toast.emailVerified': 'Email verificado com sucesso! Bem-vindo ao VAIU!',
    'profile.toast.emailVerificationFailed': 'A verificação do email falhou. O link pode ter expirado ou ser inválido.',
    'profile.toast.googleMapsFailed': 'Falha ao carregar o Google Maps. Por favor, verifique sua conexão com a internet.',
    'profile.toast.autoDepositUpdated': 'Preferências de depósito automático atualizadas com sucesso',
    'profile.toast.autoDepositFailed': 'Falha ao atualizar preferências de depósito automático',
    'profile.toast.autoAcceptUpdated': 'Preferências de aceitação automática atualizadas com sucesso',
    'profile.toast.autoAcceptFailed': 'Falha ao atualizar preferências de aceitação automática',
    'profile.toast.invoicePaymentUpdated': 'Preferências de pagamento de fatura atualizadas com sucesso',
    'profile.toast.profileUpdated': 'Perfil atualizado com sucesso',
    'profile.toast.profileUpdateFailed': 'Falha ao atualizar perfil',
    'profile.toast.verificationEmailSent': 'Email de verificação enviado',
    'profile.toast.verificationEmailFailed': 'Falha ao enviar email de verificação',
    'profile.toast.pinsDoNotMatch': 'Os PINs não correspondem',
    'profile.toast.pinUpdated': 'PIN atualizado com sucesso',
    'profile.toast.pinUpdateFailed': 'Falha ao atualizar PIN',
    'profile.toast.pinSettingUpdated': 'Configuração do PIN atualizada',
    'profile.toast.pinSettingFailed': 'Falha ao atualizar configuração do PIN',
    'profile.toast.transferOutUpdated': 'Preferências de transferência atualizadas com sucesso',
    'profile.toast.transferOutFailed': 'Falha ao atualizar preferências de transferência',
    'profile.toast.addressAdded': 'Endereço adicionado com sucesso',
    'profile.toast.addressUpdated': 'Endereço atualizado com sucesso',
    'profile.toast.addressDeleteFailed': 'Falha ao salvar endereço',
    'profile.toast.addressDeleted': 'Endereço excluído com sucesso',
    'profile.toast.addressDeleteError': 'Falha ao excluir endereço',
    'profile.toast.primaryAddressUpdated': 'Endereço principal atualizado',
    'profile.toast.primaryAddressFailed': 'Falha ao atualizar endereço principal',
    'profile.toast.merchantStatusEnabled': 'Status de comerciante habilitado',
    'profile.toast.merchantStatusDisabled': 'Status de comerciante desabilitado',
    'profile.toast.merchantStatusFailed': 'Falha ao atualizar status de comerciante',
    'profile.toast.developerAccessEnabled': 'Acesso de desenvolvedor habilitado! Agora você pode acessar o Console do Desenvolvedor.',
    'profile.toast.developerAccessFailed': 'Falha ao habilitar acesso de desenvolvedor',
  },
  de: {
    'profile.pageTitle': 'Profilverwaltung',
    'profile.pageSubtitle': 'Verwalten Sie Ihre Kontoinformationen und Einstellungen',
    'profile.title': 'Profilverwaltung',
    'profile.subtitle': 'Verwalten Sie Ihre Kontoinformationen und Einstellungen',
    'profile.loading': 'Profil wird geladen...',
    'profile.failed_to_load': 'Profil konnte nicht geladen werden',
    'profile.retry': 'Wiederholen',
    'profile.basic_info': 'Grundinformationen',
    'profile.first_name': 'Vorname',
    'profile.last_name': 'Nachname',
    'profile.contact_info': 'Kontaktinformationen',
    'profile.security': 'Sicherheitseinstellungen',
    'vaiu.profile_page.title': 'Profilverwaltung',
    'vaiu.profile_page.subtitle': 'Verwalten Sie Ihre Kontoinformationen und Einstellungen',
    'vaiu.profile_page.loading': 'Profil wird geladen...',
    'vaiu.profile_page.failed_to_load': 'Profil konnte nicht geladen werden',
    'vaiu.profile_page.retry': 'Wiederholen',
    'vaiu.profile_page.basic_info': 'Grundinformationen',
    'vaiu.profile_page.first_name': 'Vorname',
    'vaiu.profile_page.last_name': 'Nachname',
    'vaiu.profile_page.username': 'Benutzername',
    'vaiu.profile_page.contact_info': 'Kontaktinformationen',
    'vaiu.profile_page.security': 'Sicherheitseinstellungen',
    'vaiu.profile_page.transfer_out.title': 'Ausgangs-Überweisungs-Einstellungen',
    'vaiu.profile_page.transfer_out.description': 'Konfigurieren Sie Ihre bevorzugten Zahlungsmethoden für die Überweisung von Geldern von Ihrem Konto.',
    'vaiu.profile_page.transfer_out.paypal_email': 'PayPal-E-Mail',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Diese E-Mail wird für PayPal-Auszahlungen verwendet, wenn Sie Gelder überweisen.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Aktivierte Zahlungsmethoden',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Wählen Sie die Zahlungsmethoden aus, die Sie für die Überweisung von Geldern verwenden möchten.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Gelder auf Ihr PayPal-Konto überweisen',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Bankkonten',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Gelder auf Ihre verbundenen Bankkonten überweisen',
    'vaiu.profile_page.transfer_out.merchant_info': 'Händlerinformationen',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Stripe Connect-Konto',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Verbunden: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Nicht verbunden - Richten Sie Stripe Connect für direkte Überweisungen ein',
    'vaiu.profile_page.transfer_out.not_set': 'Nicht festgelegt',
    'vaiu.profile_page.transfer_out.configured': 'Konfiguriert',
    'vaiu.profile_page.transfer_out.not_configured': 'Nicht Konfiguriert',
    'vaiu.profile_page.transfer_out.enabled': 'Aktiviert',
    'vaiu.profile_page.transfer_out.disabled': 'Deaktiviert',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'MeMoney-Guthaben (MM$) werden noch End-to-End getestet; Beträge und Zeitpunkte können ungenau sein.',

    'profile.overview': 'Profilübersicht',
    'profile.balances': 'Kontostände',
    'profile.landingPage': 'Startseiten-Einstellungen',
    'profile.addresses': 'Adressen',
    'profile.transferOut': 'Ausgangs-Überweisungs-Einstellungen',
    'profile.autoDeposit': 'Automatische Einzahlungs-Einstellungen',
    'profile.businessSettings': 'Geschäftseinstellungen',
    'profile.accountInfo': 'Kontoinformationen',
    'profile.debugInfo': 'Debug-Informationen',
    'profile.toast.failedToLoad': 'Profil konnte nicht geladen werden',
    'profile.toast.emailVerified': 'E-Mail erfolgreich verifiziert! Willkommen bei VAIU!',
    'profile.toast.emailVerificationFailed': 'E-Mail-Verifizierung fehlgeschlagen. Der Link ist möglicherweise abgelaufen oder ungültig.',
    'profile.toast.googleMapsFailed': 'Google Maps konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung.',
    'profile.toast.autoDepositUpdated': 'Einstellungen für automatische Einzahlung erfolgreich aktualisiert',
    'profile.toast.autoDepositFailed': 'Einstellungen für automatische Einzahlung konnten nicht aktualisiert werden',
    'profile.toast.autoAcceptUpdated': 'Einstellungen für automatische Annahme erfolgreich aktualisiert',
    'profile.toast.autoAcceptFailed': 'Einstellungen für automatische Annahme konnten nicht aktualisiert werden',
    'profile.toast.invoicePaymentUpdated': 'Einstellungen für Rechnungszahlung erfolgreich aktualisiert',
    'profile.toast.profileUpdated': 'Profil erfolgreich aktualisiert',
    'profile.toast.profileUpdateFailed': 'Profil konnte nicht aktualisiert werden',
    'profile.toast.verificationEmailSent': 'Verifizierungs-E-Mail gesendet',
    'profile.toast.verificationEmailFailed': 'Verifizierungs-E-Mail konnte nicht gesendet werden',
    'profile.toast.pinsDoNotMatch': 'PINs stimmen nicht überein',
    'profile.toast.pinUpdated': 'PIN erfolgreich aktualisiert',
    'profile.toast.pinUpdateFailed': 'PIN konnte nicht aktualisiert werden',
    'profile.toast.pinSettingUpdated': 'PIN-Einstellung aktualisiert',
    'profile.toast.pinSettingFailed': 'PIN-Einstellung konnte nicht aktualisiert werden',
    'profile.toast.transferOutUpdated': 'Einstellungen für Auszahlung erfolgreich aktualisiert',
    'profile.toast.transferOutFailed': 'Einstellungen für Auszahlung konnten nicht aktualisiert werden',
    'profile.toast.addressAdded': 'Adresse erfolgreich hinzugefügt',
    'profile.toast.addressUpdated': 'Adresse erfolgreich aktualisiert',
    'profile.toast.addressDeleteFailed': 'Adresse konnte nicht gespeichert werden',
    'profile.toast.addressDeleted': 'Adresse erfolgreich gelöscht',
    'profile.toast.addressDeleteError': 'Adresse konnte nicht gelöscht werden',
    'profile.toast.primaryAddressUpdated': 'Hauptadresse aktualisiert',
    'profile.toast.primaryAddressFailed': 'Hauptadresse konnte nicht aktualisiert werden',
    'profile.toast.merchantStatusEnabled': 'Händlerstatus aktiviert',
    'profile.toast.merchantStatusDisabled': 'Händlerstatus deaktiviert',
    'profile.toast.merchantStatusFailed': 'Händlerstatus konnte nicht aktualisiert werden',
    'profile.toast.developerAccessEnabled': 'Entwicklerzugang aktiviert! Sie können jetzt auf die Entwicklerkonsole zugreifen.',
    'profile.toast.developerAccessFailed': 'Entwicklerzugang konnte nicht aktiviert werden',
  },
  sr: {
    'profile.pageTitle': 'Управљање профилом',
    'profile.pageSubtitle': 'Управљајте информацијама и подешавањима вашег налога',
    'profile.title': 'Управљање профилом',
    'profile.subtitle': 'Управљајте информацијама и подешавањима вашег налога',
    'profile.loading': 'Учитавање профила...',
    'profile.failed_to_load': 'Неуспешно учитавање профила',
    'profile.retry': 'Покушај поново',
    'profile.basic_info': 'Основне информације',
    'profile.first_name': 'Име',
    'profile.last_name': 'Презиме',
    'profile.contact_info': 'Контакт информације',
    'profile.security': 'Подешавања безбедности',
    'vaiu.profile_page.title': 'Управљање профилом',
    'vaiu.profile_page.subtitle': 'Управљајте информацијама и подешавањима вашег налога',
    'vaiu.profile_page.loading': 'Учитавање профила...',
    'vaiu.profile_page.failed_to_load': 'Неуспешно учитавање профила',
    'vaiu.profile_page.retry': 'Покушај поново',
    'vaiu.profile_page.basic_info': 'Основне информације',
    'vaiu.profile_page.first_name': 'Име',
    'vaiu.profile_page.last_name': 'Презиме',
    'vaiu.profile_page.username': 'Корисничко име',
    'vaiu.profile_page.contact_info': 'Контакт информације',
    'vaiu.profile_page.security': 'Подешавања безбедности',
    'vaiu.profile_page.transfer_out.title': 'Подешавања за пренос',
    'vaiu.profile_page.transfer_out.description': 'Подесите ваше жељене начине плаћања за пренос средстава са вашег налога.',
    'vaiu.profile_page.transfer_out.paypal_email': 'PayPal Email',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Овај email ће се користити за PayPal исплате када преносите средства.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Омогућени начини плаћања',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Изаберите начине плаћања које желите да користите за пренос средстава.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Пренос средстава на ваш PayPal налог',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Банковни рачуни',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Пренос средстава на ваше повезане банковне рачуне',
    'vaiu.profile_page.transfer_out.merchant_info': 'Информације о трговцу',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Stripe Connect налог',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Повезано: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Није повезано - Подесите Stripe Connect за директне преносе',
    'vaiu.profile_page.transfer_out.not_set': 'Није постављено',
    'vaiu.profile_page.transfer_out.configured': 'Подешено',
    'vaiu.profile_page.transfer_out.not_configured': 'Није Подешено',
    'vaiu.profile_page.transfer_out.enabled': 'Омогућено',
    'vaiu.profile_page.transfer_out.disabled': 'Онемогућено',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'MeMoney салда (MM$) су још у тестирању; износи и рокови можда нису коначни.',

    'profile.overview': 'Преглед профила',
    'profile.balances': 'Стања на рачуну',
    'profile.landingPage': 'Подешавања почетне странице',
    'profile.addresses': 'Адресе',
    'profile.transferOut': 'Подешавања за пренос',
    'profile.autoDeposit': 'Подешавања за аутоматски депозит',
    'profile.businessSettings': 'Пословна подешавања',
    'profile.accountInfo': 'Информације о налогу',
    'profile.debugInfo': 'Информације за отклањање грешака',
    'profile.toast.failedToLoad': 'Неуспешно учитавање података профила',
    'profile.toast.emailVerified': 'Имејл успешно верификован! Добродошли у VAIU!',
    'profile.toast.emailVerificationFailed': 'Верификација имејла није успела. Веза је можда истекла или је неважећа.',
    'profile.toast.googleMapsFailed': 'Неуспешно учитавање Google Maps. Молимо проверите вашу интернет везу.',
    'profile.toast.autoDepositUpdated': 'Подешавања аутоматског депозита успешно ажурирана',
    'profile.toast.autoDepositFailed': 'Неуспешно ажурирање подешавања аутоматског депозита',
    'profile.toast.autoAcceptUpdated': 'Подешавања аутоматског прихватања успешно ажурирана',
    'profile.toast.autoAcceptFailed': 'Неуспешно ажурирање подешавања аутоматског прихватања',
    'profile.toast.invoicePaymentUpdated': 'Подешавања плаћања рачуна успешно ажурирана',
    'profile.toast.profileUpdated': 'Профил успешно ажуриран',
    'profile.toast.profileUpdateFailed': 'Неуспешно ажурирање профила',
    'profile.toast.verificationEmailSent': 'Имејл за верификацију послат',
    'profile.toast.verificationEmailFailed': 'Неуспешно слање имејла за верификацију',
    'profile.toast.pinsDoNotMatch': 'PIN-ови се не поклапају',
    'profile.toast.pinUpdated': 'PIN успешно ажуриран',
    'profile.toast.pinUpdateFailed': 'Неуспешно ажурирање PIN-а',
    'profile.toast.pinSettingUpdated': 'Подешавање PIN-а ажурирано',
    'profile.toast.pinSettingFailed': 'Неуспешно ажурирање подешавања PIN-а',
    'profile.toast.transferOutUpdated': 'Подешавања трансфера успешно ажурирана',
    'profile.toast.transferOutFailed': 'Неуспешно ажурирање подешавања трансфера',
    'profile.toast.addressAdded': 'Адреса успешно додата',
    'profile.toast.addressUpdated': 'Адреса успешно ажурирана',
    'profile.toast.addressDeleteFailed': 'Неуспешно чување адресе',
    'profile.toast.addressDeleted': 'Адреса успешно обрисана',
    'profile.toast.addressDeleteError': 'Неуспешно брисање адресе',
    'profile.toast.primaryAddressUpdated': 'Примарна адреса ажурирана',
    'profile.toast.primaryAddressFailed': 'Неуспешно ажурирање примарне адресе',
    'profile.toast.merchantStatusEnabled': 'Статус трговца омогућен',
    'profile.toast.merchantStatusDisabled': 'Статус трговца онемогућен',
    'profile.toast.merchantStatusFailed': 'Неуспешно ажурирање статуса трговца',
    'profile.toast.developerAccessEnabled': 'Приступ програмеру омогућен! Сада можете приступити Конзоли програмера.',
    'profile.toast.developerAccessFailed': 'Неуспешно омогућавање приступа програмеру',
  },
  pl: {
    'profile.pageTitle': 'Zarządzanie Profilem',
    'profile.pageSubtitle': 'Zarządzaj informacjami i ustawieniami swojego konta',
    'profile.title': 'Zarządzanie Profilem',
    'profile.subtitle': 'Zarządzaj informacjami i ustawieniami swojego konta',
    'profile.loading': 'Ładowanie profilu...',
    'profile.failed_to_load': 'Nie udało się załadować profilu',
    'profile.retry': 'Spróbuj ponownie',
    'profile.basic_info': 'Podstawowe Informacje',
    'profile.first_name': 'Imię',
    'profile.last_name': 'Nazwisko',
    'profile.contact_info': 'Informacje Kontaktowe',
    'profile.security': 'Ustawienia Bezpieczeństwa',
    'vaiu.profile_page.title': 'Zarządzanie Profilem',
    'vaiu.profile_page.subtitle': 'Zarządzaj informacjami i ustawieniami swojego konta',
    'vaiu.profile_page.loading': 'Ładowanie profilu...',
    'vaiu.profile_page.failed_to_load': 'Nie udało się załadować profilu',
    'vaiu.profile_page.retry': 'Spróbuj ponownie',
    'vaiu.profile_page.basic_info': 'Podstawowe Informacje',
    'vaiu.profile_page.first_name': 'Imię',
    'vaiu.profile_page.last_name': 'Nazwisko',
    'vaiu.profile_page.username': 'Nazwa użytkownika',
    'vaiu.profile_page.contact_info': 'Informacje Kontaktowe',
    'vaiu.profile_page.security': 'Ustawienia Bezpieczeństwa',
    'vaiu.profile_page.transfer_out.title': 'Preferencje Transferu Wychodzącego',
    'vaiu.profile_page.transfer_out.description': 'Skonfiguruj preferowane metody płatności do transferowania środków z konta.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Ten email będzie używany do wypłat PayPal podczas transferowania środków.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Włączone Metody Płatności',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Wybierz metody płatności, które chcesz używać do transferowania środków.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transferuj środki na swoje konto PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Konta Bankowe',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transferuj środki na swoje połączone konta bankowe',
    'vaiu.profile_page.transfer_out.merchant_info': 'Informacje o Sprzedawcy',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Konto Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Połączono: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Nie połączono - Skonfiguruj Stripe Connect dla bezpośrednich transferów',
    'vaiu.profile_page.transfer_out.not_set': 'Nie ustawiono',
    'vaiu.profile_page.transfer_out.configured': 'Skonfigurowano',
    'vaiu.profile_page.transfer_out.not_configured': 'Nie Skonfigurowano',
    'vaiu.profile_page.transfer_out.enabled': 'Włączone',
    'vaiu.profile_page.transfer_out.disabled': 'Wyłączone',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Salda MeMoney (MM$) są w testach end-to-end; kwoty i terminy mogą być nieostateczne.',

    'profile.overview': 'Przegląd Profilu',
    'profile.balances': 'Salda Konta',
    'profile.landingPage': 'Preferencje Strony Głównej',
    'profile.addresses': 'Adresy',
    'profile.transferOut': 'Preferencje Transferu Wychodzącego',
    'profile.autoDeposit': 'Preferencje Automatycznego Depozytu',
    'profile.businessSettings': 'Ustawienia Biznesowe',
    'profile.accountInfo': 'Informacje o Koncie',
    'profile.debugInfo': 'Informacje Debugowania',
    'profile.toast.failedToLoad': 'Nie udało się załadować danych profilu',
    'profile.toast.emailVerified': 'Email pomyślnie zweryfikowany! Witamy w VAIU!',
    'profile.toast.emailVerificationFailed': 'Weryfikacja email nie powiodła się. Link mógł wygasnąć lub być nieprawidłowy.',
    'profile.toast.googleMapsFailed': 'Nie udało się załadować Google Maps. Sprawdź połączenie internetowe.',
    'profile.toast.autoDepositUpdated': 'Preferencje automatycznego depozytu zaktualizowane pomyślnie',
    'profile.toast.autoDepositFailed': 'Nie udało się zaktualizować preferencji automatycznego depozytu',
    'profile.toast.autoAcceptUpdated': 'Preferencje automatycznej akceptacji zaktualizowane pomyślnie',
    'profile.toast.autoAcceptFailed': 'Nie udało się zaktualizować preferencji automatycznej akceptacji',
    'profile.toast.invoicePaymentUpdated': 'Preferencje płatności faktur zaktualizowane pomyślnie',
    'profile.toast.profileUpdated': 'Profil zaktualizowany pomyślnie',
    'profile.toast.profileUpdateFailed': 'Nie udało się zaktualizować profilu',
    'profile.toast.verificationEmailSent': 'Email weryfikacyjny wysłany',
    'profile.toast.verificationEmailFailed': 'Nie udało się wysłać emaila weryfikacyjnego',
    'profile.toast.pinsDoNotMatch': 'PIN-y nie pasują',
    'profile.toast.pinUpdated': 'PIN zaktualizowany pomyślnie',
    'profile.toast.pinUpdateFailed': 'Nie udało się zaktualizować PIN',
    'profile.toast.pinSettingUpdated': 'Ustawienie PIN zaktualizowane',
    'profile.toast.pinSettingFailed': 'Nie udało się zaktualizować ustawienia PIN',
    'profile.toast.transferOutUpdated': 'Preferencje transferu zaktualizowane pomyślnie',
    'profile.toast.transferOutFailed': 'Nie udało się zaktualizować preferencji transferu',
    'profile.toast.addressAdded': 'Adres dodany pomyślnie',
    'profile.toast.addressUpdated': 'Adres zaktualizowany pomyślnie',
    'profile.toast.addressDeleteFailed': 'Nie udało się zapisać adresu',
    'profile.toast.addressDeleted': 'Adres usunięty pomyślnie',
    'profile.toast.addressDeleteError': 'Nie udało się usunąć adresu',
    'profile.toast.primaryAddressUpdated': 'Adres główny zaktualizowany',
    'profile.toast.primaryAddressFailed': 'Nie udało się zaktualizować adresu głównego',
    'profile.toast.merchantStatusEnabled': 'Status sprzedawcy włączony',
    'profile.toast.merchantStatusDisabled': 'Status sprzedawcy wyłączony',
    'profile.toast.merchantStatusFailed': 'Nie udało się zaktualizować statusu sprzedawcy',
    'profile.toast.developerAccessEnabled': 'Dostęp dewelopera włączony! Możesz teraz uzyskać dostęp do Konsoli Dewelopera.',
    'profile.toast.developerAccessFailed': 'Nie udało się włączyć dostępu dewelopera',
  },
  el: {
    'profile.pageTitle': 'Διαχείριση Προφίλ',
    'profile.pageSubtitle': 'Διαχειριστείτε τις πληροφορίες και τις ρυθμίσεις του λογαριασμού σας',
    'profile.title': 'Διαχείριση Προφίλ',
    'profile.subtitle': 'Διαχειριστείτε τις πληροφορίες και τις ρυθμίσεις του λογαριασμού σας',
    'profile.loading': 'Φόρτωση προφίλ...',
    'profile.failed_to_load': 'Αποτυχία φόρτωσης προφίλ',
    'profile.retry': 'Δοκιμή ξανά',
    'profile.basic_info': 'Βασικές Πληροφορίες',
    'profile.first_name': 'Όνομα',
    'profile.last_name': 'Επώνυμο',
    'profile.contact_info': 'Στοιχεία Επικοινωνίας',
    'profile.security': 'Ρυθμίσεις Ασφαλείας',
    'vaiu.profile_page.title': 'Διαχείριση Προφίλ',
    'vaiu.profile_page.subtitle': 'Διαχειριστείτε τις πληροφορίες και τις ρυθμίσεις του λογαριασμού σας',
    'vaiu.profile_page.loading': 'Φόρτωση προφίλ...',
    'vaiu.profile_page.failed_to_load': 'Αποτυχία φόρτωσης προφίλ',
    'vaiu.profile_page.retry': 'Δοκιμή ξανά',
    'vaiu.profile_page.basic_info': 'Βασικές Πληροφορίες',
    'vaiu.profile_page.first_name': 'Όνομα',
    'vaiu.profile_page.last_name': 'Επώνυμο',
    'vaiu.profile_page.username': 'Όνομα χρήστη',
    'vaiu.profile_page.contact_info': 'Στοιχεία Επικοινωνίας',
    'vaiu.profile_page.security': 'Ρυθμίσεις Ασφαλείας',
    'vaiu.profile_page.transfer_out.title': 'Προτιμήσεις Μεταφοράς Εξόδου',
    'vaiu.profile_page.transfer_out.description': 'Ρυθμίστε τις προτιμώμενες μεθόδους πληρωμής σας για μεταφορά κεφαλαίων από τον λογαριασμό σας.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Αυτό το email θα χρησιμοποιηθεί για πληρωμές PayPal όταν μεταφέρετε κεφάλαια.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Ενεργοποιημένες Μέθοδοι Πληρωμής',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Επιλέξτε ποιες μεθόδους πληρωμής θέλετε να χρησιμοποιήσετε για μεταφορά κεφαλαίων.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Μεταφέρετε κεφάλαια στον λογαριασμό σας PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Τραπεζικοί Λογαριασμοί',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Μεταφέρετε κεφάλαια στους συνδεδεμένους τραπεζικούς λογαριασμούς σας',
    'vaiu.profile_page.transfer_out.merchant_info': 'Πληροφορίες Εμπόρου',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Λογαριασμός Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Συνδεδεμένο: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Δεν είναι συνδεδεμένο - Ρυθμίστε το Stripe Connect για άμεσες μεταφορές',
    'vaiu.profile_page.transfer_out.not_set': 'Δεν έχει οριστεί',
    'vaiu.profile_page.transfer_out.configured': 'Ρυθμισμένο',
    'vaiu.profile_page.transfer_out.not_configured': 'Δεν Ρυθμίστηκε',
    'vaiu.profile_page.transfer_out.enabled': 'Ενεργοποιημένο',
    'vaiu.profile_page.transfer_out.disabled': 'Απενεργοποιημένο',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Τα υπόλοιπα MeMoney (MM$) εξακολουθούν να δοκιμάζονται· τα ποσά και οι χρόνοι μπορεί να μην είναι τελικά.',

    'profile.overview': 'Επισκόπηση Προφίλ',
    'profile.balances': 'Υπόλοιπα Λογαριασμού',
    'profile.landingPage': 'Προτιμήσεις Αρχικής Σελίδας',
    'profile.addresses': 'Διευθύνσεις',
    'profile.transferOut': 'Προτιμήσεις Μεταφοράς Εξόδου',
    'profile.autoDeposit': 'Προτιμήσεις Αυτόματης Κατάθεσης',
    'profile.businessSettings': 'Ρυθμίσεις Επιχείρησης',
    'profile.accountInfo': 'Πληροφορίες Λογαριασμού',
    'profile.debugInfo': 'Πληροφορίες Εντοπισμού Σφαλμάτων',
    'profile.toast.failedToLoad': 'Αποτυχία φόρτωσης δεδομένων προφίλ',
    'profile.toast.emailVerified': 'Το email επαληθεύτηκε με επιτυχία! Καλώς ήρθατε στο VAIU!',
    'profile.toast.emailVerificationFailed': 'Η επαλήθευση email απέτυχε. Ο σύνδεσμος μπορεί να έχει λήξει ή να είναι άκυρος.',
    'profile.toast.googleMapsFailed': 'Αποτυχία φόρτωσης Google Maps. Παρακαλώ ελέγξτε τη σύνδεσή σας στο διαδίκτυο.',
    'profile.toast.autoDepositUpdated': 'Οι προτιμήσεις αυτόματης κατάθεσης ενημερώθηκαν με επιτυχία',
    'profile.toast.autoDepositFailed': 'Αποτυχία ενημέρωσης προτιμήσεων αυτόματης κατάθεσης',
    'profile.toast.autoAcceptUpdated': 'Οι προτιμήσεις αυτόματης αποδοχής ενημερώθηκαν με επιτυχία',
    'profile.toast.autoAcceptFailed': 'Αποτυχία ενημέρωσης προτιμήσεων αυτόματης αποδοχής',
    'profile.toast.invoicePaymentUpdated': 'Οι προτιμήσεις πληρωμής τιμολογίου ενημερώθηκαν με επιτυχία',
    'profile.toast.profileUpdated': 'Το προφίλ ενημερώθηκε με επιτυχία',
    'profile.toast.profileUpdateFailed': 'Αποτυχία ενημέρωσης προφίλ',
    'profile.toast.verificationEmailSent': 'Email επαλήθευσης στάλθηκε',
    'profile.toast.verificationEmailFailed': 'Αποτυχία αποστολής email επαλήθευσης',
    'profile.toast.pinsDoNotMatch': 'Τα PIN δεν ταιριάζουν',
    'profile.toast.pinUpdated': 'Το PIN ενημερώθηκε με επιτυχία',
    'profile.toast.pinUpdateFailed': 'Αποτυχία ενημέρωσης PIN',
    'profile.toast.pinSettingUpdated': 'Η ρύθμιση PIN ενημερώθηκε',
    'profile.toast.pinSettingFailed': 'Αποτυχία ενημέρωσης ρύθμισης PIN',
    'profile.toast.transferOutUpdated': 'Οι προτιμήσεις μεταφοράς ενημερώθηκαν με επιτυχία',
    'profile.toast.transferOutFailed': 'Αποτυχία ενημέρωσης προτιμήσεων μεταφοράς',
    'profile.toast.addressAdded': 'Η διεύθυνση προστέθηκε με επιτυχία',
    'profile.toast.addressUpdated': 'Η διεύθυνση ενημερώθηκε με επιτυχία',
    'profile.toast.addressDeleteFailed': 'Αποτυχία αποθήκευσης διεύθυνσης',
    'profile.toast.addressDeleted': 'Η διεύθυνση διαγράφηκε με επιτυχία',
    'profile.toast.addressDeleteError': 'Αποτυχία διαγραφής διεύθυνσης',
    'profile.toast.primaryAddressUpdated': 'Η κύρια διεύθυνση ενημερώθηκε',
    'profile.toast.primaryAddressFailed': 'Αποτυχία ενημέρωσης κύριας διεύθυνσης',
    'profile.toast.merchantStatusEnabled': 'Η κατάσταση εμπόρου ενεργοποιήθηκε',
    'profile.toast.merchantStatusDisabled': 'Η κατάσταση εμπόρου απενεργοποιήθηκε',
    'profile.toast.merchantStatusFailed': 'Αποτυχία ενημέρωσης κατάστασης εμπόρου',
    'profile.toast.developerAccessEnabled': 'Η πρόσβαση προγραμματιστή ενεργοποιήθηκε! Μπορείτε τώρα να αποκτήσετε πρόσβαση στην Κονσόλα Προγραμματιστή.',
    'profile.toast.developerAccessFailed': 'Αποτυχία ενεργοποίησης πρόσβασης προγραμματιστή',
  },
  ro: {
    'profile.pageTitle': 'Gestionare Profil',
    'profile.pageSubtitle': 'Gestionați informațiile și setările contului dvs.',
    'profile.title': 'Gestionare Profil',
    'profile.subtitle': 'Gestionați informațiile și setările contului dvs.',
    'profile.loading': 'Se încarcă profilul...',
    'profile.failed_to_load': 'Nu s-a putut încărca profilul',
    'profile.retry': 'Încearcă din nou',
    'profile.basic_info': 'Informații de Bază',
    'profile.first_name': 'Prenume',
    'profile.last_name': 'Nume de Familie',
    'profile.contact_info': 'Informații de Contact',
    'profile.security': 'Setări de Securitate',
    'vaiu.profile_page.title': 'Gestionare Profil',
    'vaiu.profile_page.subtitle': 'Gestionați informațiile și setările contului dvs.',
    'vaiu.profile_page.loading': 'Se încarcă profilul...',
    'vaiu.profile_page.failed_to_load': 'Nu s-a putut încărca profilul',
    'vaiu.profile_page.retry': 'Încearcă din nou',
    'vaiu.profile_page.basic_info': 'Informații de Bază',
    'vaiu.profile_page.first_name': 'Prenume',
    'vaiu.profile_page.last_name': 'Nume de Familie',
    'vaiu.profile_page.username': 'Nume de utilizator',
    'vaiu.profile_page.contact_info': 'Informații de Contact',
    'vaiu.profile_page.security': 'Setări de Securitate',
    'vaiu.profile_page.transfer_out.title': 'Preferințe Transfer Ieșire',
    'vaiu.profile_page.transfer_out.description': 'Configurați metodele de plată preferate pentru transferarea fondurilor din contul dvs.',
    'vaiu.profile_page.transfer_out.paypal_email': 'Email PayPal',
    'vaiu.profile_page.transfer_out.paypal_email_desc': 'Acest email va fi folosit pentru plățile PayPal când transferați fonduri.',
    'vaiu.profile_page.transfer_out.enabled_methods': 'Metode de Plată Activate',
    'vaiu.profile_page.transfer_out.enabled_methods_desc': 'Alegeți metodele de plată pe care doriți să le folosiți pentru transferarea fondurilor.',
    'vaiu.profile_page.transfer_out.paypal': 'PayPal',
    'vaiu.profile_page.transfer_out.paypal_desc': 'Transferați fonduri în contul dvs. PayPal',
    'vaiu.profile_page.transfer_out.bank_accounts': 'Conturi Bancare',
    'vaiu.profile_page.transfer_out.bank_accounts_desc': 'Transferați fonduri în conturile dvs. bancare conectate',
    'vaiu.profile_page.transfer_out.merchant_info': 'Informații Comerciant',
    'vaiu.profile_page.transfer_out.stripe_connect': 'Cont Stripe Connect',
    'vaiu.profile_page.transfer_out.stripe_connected': 'Conectat: {{id}}',
    'vaiu.profile_page.transfer_out.stripe_not_connected': 'Nu este conectat - Configurați Stripe Connect pentru transferuri directe',
    'vaiu.profile_page.transfer_out.not_set': 'Nu este setat',
    'vaiu.profile_page.transfer_out.configured': 'Configurat',
    'vaiu.profile_page.transfer_out.not_configured': 'Nu este Configurat',
    'vaiu.profile_page.transfer_out.enabled': 'Activat',
    'vaiu.profile_page.transfer_out.disabled': 'Dezactivat',
    'vaiu.profile_page.balances.memoney_beta_notice':
      'Soldurile MeMoney (MM$) sunt încă în testare cap-coadă; sumele și termenele pot fi nefinalizate.',

    'profile.overview': 'Prezentare Generală Profil',
    'profile.balances': 'Solduri Cont',
    'profile.landingPage': 'Preferințe Pagină Principală',
    'profile.addresses': 'Adrese',
    'profile.transferOut': 'Preferințe Transfer Ieșire',
    'profile.autoDeposit': 'Preferințe Depozit Automat',
    'profile.businessSettings': 'Setări Afaceri',
    'profile.accountInfo': 'Informații Cont',
    'profile.debugInfo': 'Informații Depanare',
    'profile.toast.failedToLoad': 'Nu s-au putut încărca datele profilului',
    'profile.toast.emailVerified': 'Email verificat cu succes! Bine ați venit la VAIU!',
    'profile.toast.emailVerificationFailed': 'Verificarea email-ului a eșuat. Link-ul poate fi expirat sau invalid.',
    'profile.toast.googleMapsFailed': 'Nu s-a putut încărca Google Maps. Vă rugăm să verificați conexiunea la internet.',
    'profile.toast.autoDepositUpdated': 'Preferințele de depozit automat au fost actualizate cu succes',
    'profile.toast.autoDepositFailed': 'Nu s-au putut actualiza preferințele de depozit automat',
    'profile.toast.autoAcceptUpdated': 'Preferințele de acceptare automată au fost actualizate cu succes',
    'profile.toast.autoAcceptFailed': 'Nu s-au putut actualiza preferințele de acceptare automată',
    'profile.toast.invoicePaymentUpdated': 'Preferințele de plată factură au fost actualizate cu succes',
    'profile.toast.profileUpdated': 'Profilul a fost actualizat cu succes',
    'profile.toast.profileUpdateFailed': 'Nu s-a putut actualiza profilul',
    'profile.toast.verificationEmailSent': 'Email de verificare trimis',
    'profile.toast.verificationEmailFailed': 'Nu s-a putut trimite email-ul de verificare',
    'profile.toast.pinsDoNotMatch': 'PIN-urile nu se potrivesc',
    'profile.toast.pinUpdated': 'PIN-ul a fost actualizat cu succes',
    'profile.toast.pinUpdateFailed': 'Nu s-a putut actualiza PIN-ul',
    'profile.toast.pinSettingUpdated': 'Setarea PIN-ului a fost actualizată',
    'profile.toast.pinSettingFailed': 'Nu s-a putut actualiza setarea PIN-ului',
    'profile.toast.transferOutUpdated': 'Preferințele de transfer au fost actualizate cu succes',
    'profile.toast.transferOutFailed': 'Nu s-au putut actualiza preferințele de transfer',
    'profile.toast.addressAdded': 'Adresa a fost adăugată cu succes',
    'profile.toast.addressUpdated': 'Adresa a fost actualizată cu succes',
    'profile.toast.addressDeleteFailed': 'Nu s-a putut salva adresa',
    'profile.toast.addressDeleted': 'Adresa a fost ștearsă cu succes',
    'profile.toast.addressDeleteError': 'Nu s-a putut șterge adresa',
    'profile.toast.primaryAddressUpdated': 'Adresa principală a fost actualizată',
    'profile.toast.primaryAddressFailed': 'Nu s-a putut actualiza adresa principală',
    'profile.toast.merchantStatusEnabled': 'Statusul comerciantului a fost activat',
    'profile.toast.merchantStatusDisabled': 'Statusul comerciantului a fost dezactivat',
    'profile.toast.merchantStatusFailed': 'Nu s-a putut actualiza statusul comerciantului',
    'profile.toast.developerAccessEnabled': 'Accesul dezvoltatorului a fost activat! Acum puteți accesa Consola Dezvoltatorului.',
    'profile.toast.developerAccessFailed': 'Nu s-a putut activa accesul dezvoltatorului',
  },
};
